import { LOADING, getModelError, isModelLoading } from '../constants';
import { DimensionsService as KoobDimensionsService } from './koob';
import { DimensionsService as DsDimensionsService } from './ds';
import createService from './createService';
import { AutoCubeService } from './AutoCubesService';
/* 
                                         
                             
                           
  
                                                          
                                       
 */
export const AutoDimensionsServiceFactory = ({ useService }, schema_name, cube_ident) => {
    const cube = useService(AutoCubeService, schema_name, cube_ident);
    const error = getModelError(cube);
    if (error)
        return Object.assign([], { error, loading: false });
    if (isModelLoading(cube))
        return Object.assign([], { error: null, loading: true });
    const [source_ident, cube_name] = (cube_ident || '').split('.'); //                                                                            
    if (!cube) {
        return Object.assign([], {
            error: 'No cube found',
            errorMessage: `No cube '${cube_ident}' found (with schema_name='${schema_name}')`,
            loading: false,
        });
    }
    const isGlobal = cube.is_global !== 0; //                   
    const dimensions = isGlobal ?
        useService(KoobDimensionsService, source_ident, cube_name) :
        useService(DsDimensionsService, schema_name, source_ident, cube_name);
    return Object.assign(dimensions, { is_global: cube.is_global }); //                             
};
export const AutoDimensionsService = createService('AutoDimensionsService', AutoDimensionsServiceFactory);
export default AutoDimensionsService;
export const AutoDimensionService = createService('AutoDimensionService', ({ useService }, schema_name, cubeId, columnName) => {
    const dimensions = useService(AutoDimensionsService, schema_name, cubeId);
    if (getModelError(dimensions))
        return new Error(getModelError(dimensions));
    if (isModelLoading(dimensions))
        return LOADING;
    return dimensions.find(c => c.name === columnName) ?? null;
});
